import { UtpCardStructure } from 'common/components';
import { ENTRANCE_DOORS_CDN_PATH } from '../../entrance-doors-constants';
import {
  AnySolution,
  FreeConsultation,
  Guarantee,
  IndividualDesign,
  InstallationServices,
} from './components';

export const ENTRANCE_DOORS_UTP_CARD_LIST: UtpCardStructure<{
  onConsultationSignupBtnClick: () => void;
}>[] = [
  {
    elementName: 'Бесплатно проконсультируем и сделаем замеры',
    header: {
      title: 'Бесплатно проконсультируем и\u00A0сделаем замеры',
      mobileTitle: 'Бесплатно проконсультируем',
    },
    description: {
      text: 'Ответим на\u00A0все вопросы, рассчитаем стоимость',
      mobileText: 'Рассчитаем стоимость, сделаем замеры',
    },
    image: {
      alt: 'Бесплатная консультация',
      src: `${ENTRANCE_DOORS_CDN_PATH}/utp/free-consultation.png/free-consultation-02.png`,
    },
    modal: { content: FreeConsultation },
  },
  {
    elementName: 'Поможем создать дизайн мечты',
    header: {
      title: 'Поможем создать дизайн мечты',
      mobileTitle: 'Создадим дизайн мечты',
    },
    description: {
      text: 'У\u00A0нас большой выбор цветов, материалов и\u00A0фурнитур',
      mobileText: 'У\u00A0нас большой выбор цветов и\u00A0материалов',
    },
    image: {
      alt: 'Различные дизайны входных дверей',
      src: `${ENTRANCE_DOORS_CDN_PATH}/utp/individual-design.png/individual-design.png`,
    },
    modal: { content: IndividualDesign },
  },
  {
    elementName: 'Изготовим дверь под ваш запрос',
    header: {
      title: 'Изготовим дверь под\u00A0ваш запрос',
    },
    description: {
      text: 'От\u00A0самой простой до\u00A0умной двери с\u00A0биометрией',
      mobileText: 'От\u00A0простой до\u00A0умной двери с\u00A0биометрией',
    },
    image: {
      alt: 'Изготовление входных дверей',
      src: `${ENTRANCE_DOORS_CDN_PATH}/utp/any-solution.png/any-solution.png`,
    },
    modal: { content: AnySolution },
  },
  {
    elementName: 'Проконтролируем все этапы',
    header: {
      title: 'Проконтролируем все\u00A0этапы',
    },
    description: {
      text: 'Замеры, изготовление, установка\u00A0\u2014 всё под ключ',
      mobileText: 'Всё под ключ\u00A0\u2014 от\u00A0замера до\u00A0установки',
    },
    image: {
      alt: 'Контроль этапов установки входных дверей',
      src: `${ENTRANCE_DOORS_CDN_PATH}/utp/installation-services.png/installation-services-01.png`,
    },
    modal: { content: InstallationServices },
  },
  {
    elementName: 'Гарантируем качество',
    header: {
      title: 'Гарантируем качество',
    },
    description: {
      text: 'Гарантия на\u00A0дверь и\u00A0установку от\u00A01\u00A0года',
    },
    image: {
      alt: 'Различные дизайны входных дверей',
      src: `${ENTRANCE_DOORS_CDN_PATH}/utp/guarantee.png/guarantee-01.png`,
    },
    modal: { content: Guarantee },
  },
];
